module.exports = __webpack_public_path__ + "static/media/close.1a0d2caf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Frontend/assets/iconos/close.svg
// module id = 20
// module chunks = 0